import React, { FC, useEffect, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch } from '@typings/redux';
import { Dialog, DialogContent, DialogTitle, DialogActions, Box } from '@mui/material';
import { personalDataAccessStudentsListSelector } from 'store/reports/reports.selector';
import { fetchPersonalDataAccessesList } from 'store/reports/reports.action';
import { limits } from 'config/pagination';
import { useStyles } from 'components/schoolDistricts/DistrictsBrowser/AddressRuleModal/AddressRuleModal.styles';
import { useTranslator } from 'components/shared/hooks';
import { Button } from 'components/shared/buttons/Button/Button';
import { DataGrid } from 'components/shared/data/DataGrid/DataGrid';
import { ColumnsConfig } from 'components/shared/data/DataGrid/DataGrid.types';
import { StudentFullName } from '../AccessList.types';

interface PrintedStudentModalProps {
  id: string;
  open: boolean;
  handleClose: () => void;
}

export const PrintedStudentsModal: FC<PrintedStudentModalProps> = (props) => {
  const classes = useStyles();
  const trans = useTranslator();
  const dispatch = useDispatch<AppDispatch>();
  const { list, total } = useSelector(personalDataAccessStudentsListSelector);

  useEffect(() => {
    if (props.id) {
      dispatch(fetchPersonalDataAccessesList(props.id));
    }
  }, [dispatch, props.id]);

  const getColumns: ColumnsConfig<StudentFullName, void> = () => [
    {
      field: 'firstName',
      name: 'PERSONAL_DATA_ACCESS.BROWSER_PRINTER_REGISTER.PRINTED_STUDENTS_MODAL.COLUMNS.FIRST_NAME',
      format: (data) => data.firstName,
    },
    {
      field: 'lastName',
      name: 'PERSONAL_DATA_ACCESS.BROWSER_PRINTER_REGISTER.PRINTED_STUDENTS_MODAL.COLUMNS.LAST_NAME',
      format: (data) => data.lastName,
    },
  ];

  const onDataFetch = useCallback(
    (page) => dispatch(fetchPersonalDataAccessesList(props.id, page)),
    [dispatch, props.id],
  );
  const onDataProvide = useCallback((page) => list[page], [list]);

  return (
    <Dialog disableEscapeKeyDown open={props.open} maxWidth={'md'} classes={{ paper: classes.dialog }}>
      <DialogTitle>
        {trans('PERSONAL_DATA_ACCESS.BROWSER_PRINTER_LIST.PRINTED_STUDENTS_MODAL.DIALOG_TITLE')}
      </DialogTitle>
      <DialogContent className={classes.content}>
        <Box sx={{ height: 300, width: '93%' }}>
          <DataGrid<StudentFullName>
            columns={getColumns()}
            onDataProvide={onDataProvide}
            onDataFetch={onDataFetch}
            total={total}
            limit={limits.printedStudentsList}
          />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={props.handleClose} color="secondary" variant="contained">
          {trans('COMMON.BACK')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
